import { render, staticRenderFns } from "./RenovationProjectMAndEGrid.vue?vue&type=template&id=2b824041&"
import script from "./RenovationProjectMAndEGrid.vue?vue&type=script&lang=js&"
export * from "./RenovationProjectMAndEGrid.vue?vue&type=script&lang=js&"
import style0 from "./RenovationProjectMAndEGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports